export default "__VITE_ASSET__MfKltwIN__"